/**
 * Staff Coverage upsert/cancel via staff-coverage-update bot.
 */

import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { Identifier } from '@medplum/fhirtypes';
import type { CoverageCommand } from '@unify/fhir-model/schemas';

const STAFF_COVERAGE_UPDATE_BOT: Identifier = {
  system: 'https://unify.health/bots',
  value: 'staff-coverage-update',
};

function getStaffCoverageUpdateBotTarget(): string | Identifier {
  const id = import.meta.env.VITE_MEDPLUM_STAFF_COVERAGE_UPDATE_BOT_ID?.trim();
  if (id) return id;
  return STAFF_COVERAGE_UPDATE_BOT;
}

export interface StaffCoverageUpdateResult {
  coverageId: string;
  priority: 'primary' | 'secondary' | 'tertiary';
}

export async function submitStaffCoverageCommand(
  medplum: MedplumClient,
  command: CoverageCommand,
): Promise<StaffCoverageUpdateResult> {
  return medplum.executeBot(
    getStaffCoverageUpdateBotTarget(),
    command,
    ContentType.JSON,
  ) as Promise<StaffCoverageUpdateResult>;
}
